<script lang="ts">
  export type IconName = 'home' | 'workspaces' | 'activity' | 'settings' | 'search' | 'plus' | 'terminal' | 'arrow' | 'server' | 'split' | 'check' | 'close' | 'menu' | 'edit' | 'mic';
  let { name, size = 20 }: { name: IconName; size?: number } = $props();
  const paths: Record<IconName, string> = {
    close: 'm6 6 12 12M6 18 18 6',
    menu: 'M12 4h.01M12 12h.01M12 20h.01',
    edit: 'm15 5 4 4M4 20l4-1L20 7a2.8 2.8 0 0 0-4-4L4 15v5Z',
    mic: 'M9 5a3 3 0 0 1 6 0v7a3 3 0 0 1-6 0V5ZM5 11v1a7 7 0 0 0 14 0v-1M12 19v3M8 22h8',
    home: 'M3 10.5 12 3l9 7.5M5 9v11h5v-6h4v6h5V9',
    workspaces: 'M3 5h18v14H3zM3 9h18M7 5v4',
    activity: 'M3 12h4l3-7 4 14 3-7h4',
    settings: 'M4 7h16M4 17h16M8 4v6M16 14v6',
    search: 'M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm5-1 5 5',
    plus: 'M12 5v14M5 12h14',
    terminal: 'm5 7 5 5-5 5M13 17h6',
    arrow: 'M5 12h14m-5-5 5 5-5 5',
    server: 'M4 3h16v7H4zM4 14h16v7H4zM8 6.5h.01M8 17.5h.01',
    split: 'M3 4h18v16H3zM12 4v16',
    check: 'm5 12 4 4L19 6',
  };
</script>

<svg style="flex: none" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d={paths[name]} /></svg>
